export const mockAddressBook = [
  {
    id: "1",
    name: "Address name",
    address: "Address",
  },
];
